var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstitutionsIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.5221 60C86.8655 60 86.2089 59.7383 85.7077 59.2119L78.7519 51.9064C77.7494 50.8535 77.7494 49.148 78.7519 48.0982C79.7543 47.0453 81.3753 47.0423 82.3778 48.0951L87.5221 53.498L99.6222 40.7897C100.625 39.7368 102.246 39.7368 103.248 40.7897C104.251 41.8425 104.251 43.5481 103.248 44.6009L89.3365 59.2119C88.8353 59.7383 88.1787 60 87.5221 60Z",
    fill: "#136BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3335 70.0723C35.4532 70.0723 19.3335 73.0909 19.3335 85.1508C19.3335 97.206 35.3551 100.333 54.3335 100.333C73.2091 100.333 89.3335 97.3148 89.3335 85.2549C89.3335 73.1949 73.3119 70.0723 54.3335 70.0723Z",
    fill: "#136BFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.3333 58.5863C67.1879 58.5863 77.4922 48.1492 77.4922 35.1289C77.4922 22.1085 67.1879 11.6667 54.3333 11.6667C41.4786 11.6667 31.1743 22.1085 31.1743 35.1289C31.1743 48.1492 41.4786 58.5863 54.3333 58.5863Z",
    fill: "#136BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionsIcon1);
export default __webpack_public_path__ + "static/media/institutions-icon-1.e8d91a037e15161f52a5a4ac54a77c80.svg";
export { ForwardRef as ReactComponent };